import React from 'react';
import _ from 'lodash';
import UserManager from '../../core/UserManager';
import AuthDataProvider from './AuthDataProvider';
import Button from '../markup/Button';
import Input from '../markup/Input';
import { parseFormError } from '../../utils/forms';
import RouterHelper from '../../core/RouterHelper';
import localized, { messages } from '../../core/i18n';
import ResetPasswordModal from '../auth/ResetPasswordModal';
import $ from 'jquery';
import cx from 'classnames';
import Error from '../Error';
import ShallowRenderedComponent from '../base/ShallowRenderedComponent';
import RadioGroup from '../markup/RadioGroup';
import { Modal, ModalHeader } from '../markup/Modal';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';
import WhiteLabelController from '../../core/WhiteLabelController';
import DOMPurify from 'dompurify';
import PubSub from 'pubsub-js';
import MagicLinkModal from './MagicLinkModal';

class Login extends ShallowRenderedComponent {

	constructor(props) {
		super(props);
		if (UserManager.isAuthorized && UserManager.user.isActive) RouterHelper.goToDefaultRoute();
		const query = RouterHelper.currentQuery();
		this.state = {
			error: DOMPurify.sanitize(query.error),
			from: query.from,
			userName: '',
			password: '',
			phoneNumber: '',
			authToken: '',
			authSession: '',
			twoFactorStep: 0,
			method: 0,
			retries: null,
			verificationCode: { 1: null, 2: null, 3: null, 4: null, 5: null, 6: null },
			onSendingCode: false,
			onSendingMethod: false,
			isLoadingGoogleAuth: false,
			...this.state
		};
		this.initialState = this.state;
		this.firstInput = React.createRef();
	}

	componentDidMount() {
		super.componentDidMount();
		RouterHelper.setTitle('Sign In');
	}

	componentDidUpdate() {
		const { twoFactorStep, verificationCode } = this.state;
		if (twoFactorStep == 2 && verificationCode[1] == null) this.firstInput.current.focus();
	}

	onLogin = () => {
		const { userName, password } = this.state;
		return this.trackPromise(AuthDataProvider.login(userName, password))
			.then(data => this.setState({ userName: data.username, phoneNumber: data.phone_number, authToken: data.auth_token, twoFactorStep: 1 }))
			.catch(error => this.setState({ error }));
	};

	onSendMethod = () => {
		const { authToken, method } = this.state;
		return this.setState({ onSendingMethod: true }, () => {
			return this.trackPromise(AuthDataProvider.sendAuthMethod(authToken, method==0?'email':'text'))
				.then(data => {
					$('#resend-code').modal('hide');
					return this.setState({ authSession: data.session, retries: Number(data.retries), twoFactorStep: 2 })
				})
				.catch(err => this.showErrorModal('Error sending validation method', err))
				.finally(() => this.setState({ onSendingMethod: false }));
		})
	}

	onSendCode = () => {
		const { verificationCode, authSession, authToken, from } = this.state;
		const code = Object.values(verificationCode).join('');
		return this.setState({ onSendingCode: true }, () => {
			return this.trackPromise(AuthDataProvider.sendVerificationCode(authToken, authSession, Number(code)))
				.then(data => UserManager.setUserDataAvailable(data, from))
				.catch(error => {
					$('#c-1').focus(); $('.code-input').val('');
					this.setState({verificationCode: this.initialState.verificationCode})
					if (error.responseStatus == 400 && error.json.retries) {
						return this.setState({ retries: error.json.retries, authSession: error.json.session });
					}
					if (error.json) {
						if (error.json.message) {
							this.showLastStepErrorModal();
							return this.setState({ ...this.initialState, errorMessage: error.json.message }, () => this.showLastStepErrorModal());
						}

					}
				})
				.finally(() => this.setState({ onSendingCode: false }));
		});
	}

	showResetModal = () => {
		$('#reset-password').modal('show');
	};

	showMagicLoginModal = () => {
		$('#magic-link').modal('show');
	}

	showResendCodeModal = () => {
		$('#resend-code').modal('show');
	}

	showLastStepErrorModal = () => {
		$('#last-error').modal('show');
	}

	onYoutubeAuth = () => {
		return UserManager.authByGoogle()
			.then(response => {
				this.setState({ isLoadingGoogleAuth: true });
				return this.trackPromise(AuthDataProvider.sendChannelAuthentication(response));
			})
			.then(({auth_token}) => UserManager.authToken = auth_token)
			.then(() => {
				UserManager.autoLogin();
				if (new Date('07/13/2024') > new Date()) PubSub.publish('SHOW_BETA_POPUP');
			})
			.then(() => setTimeout(() => RouterHelper.goToDefaultRoute(), 300))
			.catch(err => {
				this.setState({ error: err, isLoadingGoogleAuth: false });
			})
	};

	handleCodeInput = (place, e) => {
		const  { verificationCode } = this.state;
		const codeContainer = { ...verificationCode };
		const regex = /[0-9]/;
		if (e.type == 'change') {
			const code = e.currentTarget.value;
			if(regex.test(code)) {
				codeContainer[place] = code[0];
				if (place !== 6) {
					$(`#c-${place+1}`).val('');
					$(`#c-${place+1}`).focus();
				}
			} else {
				$(`#c-${place}`).val('');
			}
			return this.setState({ verificationCode: codeContainer }, () => { if (place == 6 && !_.isEmpty(code)) this.onSendCode(); });
		} else if (e.type == 'paste') {
			const code = e.clipboardData.getData('text').replace(/[^\d]/g, '');
			if(regex.test(code)) {
				for (let i = place, j = 0; j < code.length; i++, j++) {
					codeContainer[i] = code[j];
					$(`#c-${i}`).val(code[j]);
				}
			}
			return this.setState({ verificationCode: codeContainer }, () => { if (code.length == 6) this.onSendCode(); });
		}
	}

	handleCodeDeletion = (place, e) => {
		if (e.keyCode === 8) {
			$(`#c-${place-1}`).val('');
			$(`#c-${place-1}`).focus();
		}
	}

	renderBrandLogin = () => {
		const { error, userName, password } = this.state;
		const formError = parseFormError(error);
		const generalError = formError.generalError || formError.message;
		const redirectUrl = error.json?.redirect_url;
		return (
			<div>
				<form id="login-form">
					{generalError && <div className="form-general-error mb-10">
						<Error error={generalError}/>
						<a className='fc-red-light' href={redirectUrl}>{redirectUrl}</a>
					</div>}
					<small className="text-grey">{localized(messages.LOGIN_PAGE.EMAIL)}</small>
					<Input type="email" autoFocus={true} id="userName"
						value={userName} onChange={e => this.setState({userName: e})}
						error={formError.username}/>
					<small className="text-grey">{localized(messages.LOGIN_PAGE.PASSWORD)}</small>
					<Input type="password" id="password" showPasswordEye={true}
						value={password} onChange={e => this.setState({password: e})}
						error={formError.password}/>
				</form>
				<div className="text-center full-width">
					<Button id="login-btn" className="login-button-black" pendingTitle="Logging in..." formID="login-form" onClick={this.onLogin} data-testid="login-button-main">Login</Button>
					<div className="login-button-grey" onClick={() => RouterHelper.goTo('/brand_register/')}>Register as a Brand</div>
					<div className="mt-10"><a className="forgot-password" href="#" onClick={this.showResetModal}>{localized(messages.LOGIN_PAGE.FORGOT_PASSWORD)}</a></div>
					<div className="mt-10"><a className="forgot-password" href="#" onClick={this.showMagicLoginModal}>Login via Email Link</a></div>
				</div>
			</div>
		)
	}

	renderTwoFactorAuthMethod = () => {
		const { twoFactorStep, phoneNumber, method, onSendingMethod } = this.state;
		return (
			<div className={`two-factor-container method ${twoFactorStep==1?'active':''}`}>
				<div className='header'>
					Select Method for Validation
				</div>
				<div className='body'>
					<RadioGroup id='login-methods ' className='login-radio' options={[{id: 0, title: 'Email', icon: 'fa-envelope'}, {id: 1, title: 'Phone Number', icon: 'fa-mobile',  disabled: _.isEmpty(phoneNumber)?true:false}]}
						iconKey='icon' onSelect={opt => this.setState({ method: opt.id })} selectedOptionID={method} />
					{!_.isEmpty(phoneNumber) && <span className='phone-number'>{phoneNumber}</span>}
					{_.isEmpty(phoneNumber) && <span className='phone-number'>Not provided yet</span>}
					<Button className="login-button-black" onClick={() => this.onSendMethod()} data-testid="next-button-main">
						{onSendingMethod ? 'Sending...' : 'Next'}
					</Button>
					<span className='back-btn' onClick={() => this.setState({ phoneNumber: '', authToken: '', twoFactorStep: 0 })}>&lt;&lt; Back</span>
				</div>
			</div>
		)
	}

	renderTwoFactorAuthCode = () => {
		const { twoFactorStep, retries, verificationCode, onSendingCode, onSendingMethod } = this.state;
		return (
			<div className={`two-factor-container code ${twoFactorStep==2?'active':''}`}>
				<div className='header'>
					Enter Validation Code
				</div>
				<div className='body'>
					<div className='code-message'>
						{ retries == 5 ?
							<span>We just sent your code<br/>please enter it here</span> :
							<span style={{color: '#cc1919'}}>Wrong code, please try again.<br/>{retries} attempts remaining</span>}
					</div>
					<div className='code-container'>
							<input id='c-1' ref={this.firstInput} className='code-input' maxLength={1} onPaste={e => this.handleCodeInput(1, e)} onChange={e => this.handleCodeInput(1, e)} onClick={() => $('#c-1').val('')} autoComplete="one-time-code"/>
							<input id='c-2' className='code-input' maxLength={1} onPaste={e => this.handleCodeInput(2, e)} onChange={e => this.handleCodeInput(2, e)} onClick={() => $('#c-2').val('')} onKeyDown={e => this.handleCodeDeletion(2, e)}/>
							<input id='c-3' className='code-input' maxLength={1} onPaste={e => this.handleCodeInput(3, e)} onChange={e => this.handleCodeInput(3, e)} onClick={() => $('#c-3').val('')} onKeyDown={e => this.handleCodeDeletion(3, e)}/>
							<span style={{ marginRight: '8px' }}>-</span>
							<input id='c-4' className='code-input' maxLength={1} onPaste={e => this.handleCodeInput(4, e)} onChange={e => this.handleCodeInput(4, e)} onClick={() => $('#c-4').val('')} onKeyDown={e => this.handleCodeDeletion(4, e)}/>
							<input id='c-5' className='code-input' maxLength={1} onPaste={e => this.handleCodeInput(5, e)} onChange={e => this.handleCodeInput(5, e)} onClick={() => $('#c-5').val('')} onKeyDown={e => this.handleCodeDeletion(5, e)}/>
							<input id='c-6' className='code-input' maxLength={1} onPaste={e => this.handleCodeInput(6, e)} onChange={e => this.handleCodeInput(6, e)} onClick={() => $('#c-6').val('')} onKeyDown={e => this.handleCodeDeletion(6, e)}/>
					</div>
					<div className='btn-container'>
						<Button className="login-button-black mb-15" pendingTitle="Submitting..." onClick={() => this.onSendCode()} disabled={onSendingCode || Object.values(verificationCode).join('').length < 6}>
							{onSendingCode ? 'Submitting...' : 'Confirm'}
						</Button>
						<div className='extra-controls'>
							<span className='back-btn' onClick={() => this.setState({ retries: '', authSession: '', twoFactorStep: 1 })}>&lt;&lt; Back</span>
							<span className='back-btn' onClick={() => this.showResendCodeModal()}>Didn't get a code?</span>
						</div>
					</div>
				</div>
				<Modal style={{ width: '360px' }} id='resend-code'>
					<i className="fa fa-times" aria-hidden="true" onClick={() => $('#resend-code').modal('hide')}></i>
					<div className='title'>Didn't get a code?</div>
					<div className='main-text'>
						<span>If you requested to send the code to your email, please check your spam box.</span>
						<span className='mt-15'> Otherwise, please either wait or click to send a new code.</span>
					</div>
					<Button className="login-button-black" pendingTitle="Sending..." onClick={() => {
						$('.code-input').val('');
						this.onSendMethod();
					}}>
						{onSendingMethod ? 'Sending...' : 'SEND NEW CODE'}
					</Button>
				</Modal>
			</div>
		)
	}

	renderLoadingAuthOverlay = () => {
		const { isLoadingGoogleAuth } = this.state;
		return (
			<div className={`g-auth-overlay ${isLoadingGoogleAuth?'active':''}`}>
				<img src={WhiteLabelController.siteAssets.logo} className='logo'/>
				<span className='text'>Logging you in ...</span>
				<i className="material-icons rotating-i">hourglass_empty</i>
			</div>
		)
	}

	render() {
		const { twoFactorStep, errorMessage, isLoadingGoogleAuth } = this.state;
		const { domainAccessToGoogleOAuth } = UserManager.user;
		const loginTabs = domainAccessToGoogleOAuth ?
			<div className="login-tabs mb-25">
				<div className={cx('brand-tab active')}>
					Brand Login
				</div>
			</div> : <div className="login-tabs mb-25"><div className='brand-tab active no-gauth'>Log In</div></div>;
		return (
			<div style={{backgroundImage:'url(https://viewiq-ui-assets.s3.amazonaws.com/common/login_background.png)', backgroundPosition:'center', backgroundRepeat:'no-repeat', backgroundSize:'cover', height:'100%', width:'100%', position:'absolute'}}>
				<section className="page-header">
					{WhiteLabelController.siteAssets.logo &&  <div className="main-logo">
						<img className="logo" src={WhiteLabelController.siteAssets.logo}/>
					</div>}
					<b style={{ color: '#363636', marginTop: '19px' }}>{localized(messages.HOME_PAGE.HEADER.SIGN_IN).toUpperCase()}</b>
				</section>
				<section className={`auth-widget ${twoFactorStep==0&&!isLoadingGoogleAuth?'active':''}`}>
					{loginTabs}
					<div className="login-body h-pad-35 pb-25">
						{this.renderBrandLogin()}
					</div>
				</section>
				{this.renderTwoFactorAuthMethod()}
				{this.renderTwoFactorAuthCode()}
				{this.renderLoadingAuthOverlay()}
				<Modal size={Modal.SIZE.LARGE} id='privacy-policy-modal'>
					<ModalHeader>
						<span className="close" data-dismiss="modal" aria-hidden="true">×</span>
						<h4 className="modal-title">Terms of Service and Privacy Policy</h4>
					</ModalHeader>
					<TermsAndConditions />
					<PrivacyPolicy />
				</Modal>
				<Modal style={{ width: '340px' }} id='last-error' data-dismiss='modal'>
					<div className='title'>Login Error</div>
					<div className='main-text'>
						<span>{errorMessage}</span>
					</div>
					<Button className="login-button-black" onClick={() => $('#last-error').modal('hide')}>CLOSE</Button>
				</Modal>
				<ResetPasswordModal id="reset-password"/>
				<MagicLinkModal id='magic-link'/>
			</div>
		);
	}
}

export default Login;
